import { createContext } from "react";

const ContextStore = createContext({})

export default ContextStore